import { CSSProperties, ReactNode } from 'react';
import { Badge as MantineBadge, createStyles } from '@mantine/core';
import { dateToString, isDark } from '@/utils/utils';

import themeVariables from '@/styles/themeVariables';


const useBadgeStyles = createStyles((_, dark: any) => ({
  badge: {
    borderRadius: 4,
    padding: '3px 5px',
    textTransform: 'none',
    alignItems: 'center',
    color: dark?.dark
      ? themeVariables.darkMode.neutral(dark?.dark)
      : themeVariables.label.alternative,
    width: 'fit-content',
    backgroundColor: themeVariables.colors.badgeBackground,
    'span > svg': {
      display: 'flex',
      alignItems: 'center',
    },
  },

  badgeButton: {
    borderRadius: 4,
    padding: '3px 5px',
    color: dark?.dark
      ? themeVariables.darkMode.neutral(dark?.dark)
      : themeVariables.label.alternative,
    backgroundColor: themeVariables.colors.badgeBackground,
    width: 'fit-content',
    textTransform: 'none',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: themeVariables.colors.light200,
      color: dark?.dark
        ? themeVariables.label.normal
        : themeVariables.label.alternative,
    },
    '&:active': {
      backgroundColor: themeVariables.colors.light300,
    },
  },
}));

type BadgeProps = {
  icon?: ReactNode;
  text?: string;
  color?: string;
  backgroundColor?: string;
  style?: CSSProperties;
};

export const Badge = ({
  icon,
  text,
  color,
  backgroundColor,
  style = {},
}: BadgeProps) => {
  const { dark } = isDark();
  const { classes } = useBadgeStyles({ dark });

  return (
    <MantineBadge
      className={classes.badge}
      leftSection={icon}
      style={{
        color: color || themeVariables.darkMode.normal(dark),
        backgroundColor: backgroundColor,
        ...style,
      }}
    >
      {text}
    </MantineBadge>
  );
};

export const BadgeButton = ({ text, onClick, ...props }) => {
  const { dark } = isDark();
  const { classes } = useBadgeStyles({ dark });

  return (
    <MantineBadge className={classes.badgeButton} onClick={onClick} {...props}>
      {text}
    </MantineBadge>
  );
};

export const NewTag = ({ published }) => {
  return (
    <>
      {dateToString(new Date(published), 'YYYY-MM-DD') ==
        dateToString(new Date(), 'YYYY-MM-DD') && (
        <Badge
          color={themeVariables.colors.red300}
          backgroundColor={themeVariables.colors.red100}
          icon={undefined}
          text={'NEW'}
        />
      )}
    </>
  );
};
